import type { SVGProps } from "react";
import type { FC } from 'react';
import styled from 'styled-components';
import { iconSizeMap } from '../utils/size-map';
import type { IconSize, TokenSizeProps } from '../utils/type';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<TokenSizeProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22" {...props}><path fill="currentColor" d="M20 11a9 9 0 1 0-18 0 9 9 0 0 0 18 0m2 0c0 6.075-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0s11 4.925 11 11" /><path fill="currentColor" d="M21 10a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2z" /><path fill="currentColor" d="M11.738.325A16.3 16.3 0 0 1 16 11.021a16.3 16.3 0 0 1-4.262 10.654 1 1 0 0 1-1.476 0A16.3 16.3 0 0 1 6 10.98 16.3 16.3 0 0 1 10.262.325L11 1zM11 2.555A14.3 14.3 0 0 0 8 11a14.3 14.3 0 0 0 3 8.445A14.3 14.3 0 0 0 13.999 11a14.3 14.3 0 0 0-3-8.445" /></svg>;
const Wrapper = styled.span<{
  $size?: IconSize;
}>`
  width: ${({
  $size
}) => $size ? iconSizeMap[$size] : iconSizeMap.xs};
  height: ${({
  $size
}) => $size ? iconSizeMap[$size] : iconSizeMap.xs};
  display: inline-block;
  vertical-align: middle;
`;
const SvgGlobe = ({
  $size,
  ...rest
}: TokenSizeProps) => <Wrapper $size={$size} className="mnd-icon"><SvgBase {...rest} /></Wrapper>;
export default SvgGlobe;